// TODO remove after implementing Stripe v3
(() => {
	// angular
	// 	.module('main')
	// 	.directive('subscriptionAnnualPromo', subscriptionAnnualPromo);

	subscriptionAnnualPromo.$inject = [
		'$filter',
		'messageService',
		'promoCodeService',
		'promoCodesDataService',
		'validationService',
		'accountService'
	];

	function subscriptionAnnualPromo(
		$filter,
		messageService,
		promoCodeService,
		promoCodesDataService,
		validationService,
		accountService
	) {
		return {
			restrict: 'E',
			scope: {},
			template: `<div class="no-hover banner-body show-banner-annual-body subscription-promo main-jobs-cell m-0-i flex-wrap">
                        <div class="flex-row flex-just-space flex-basis-full flex-wrap-xs bottom-bordered border-alto-light pb-20">
                            <div class="color-dark">
                                <div class="plan">Annual</div>
                                <div  class="plan-text">2 months free! Billed annually.</div>
                            </div>
                            <div class="plan-cost-container f-green" ng-hide="user.promocodeEnabled || user.promotionActive">
                                <div class="plan-cost text-nowrap"> 
                                    <span>{{bill}}{{coin}}</span>
                                </div>
                                <div class="plan-cost-sub text-nowrap">({{label}})</div>
                            </div>
                        </div>
                        <div class="flex-basis-full pt-20">
                            <div ng-show="user.promocodeEnabled || user.promotionActive" 
                                 ng-class="{'bottom-bordered border-alto-light pb-16 mb-23' : !user.promocodeEnabled}">
                               <div class="plan-text"> 
                                    <span class="color-froly-dark f-s-18">{{discountPrice}}</span> for 1 year ({{discount}} OFF)
                               </div>
                               <div class="plan-text"> 
                                    <span class="f-green f-s-18">{{fullPrice}}</span> per year after 1 year
                               </div>
                            </div>
                            <div class="flex-row promocode-input" ng-hide="user.promocodeEnabled">
                                <input type="text" class="form-control" placeholder="Enter promo code" style="border-right: none; height: auto" ng-model="promo.code">
                                <button type="button" 
                                        class="btn btn-rectangle border-stone bg-gallery-dark" 
                                        ng-click="applyPromoCode()" 
                                        ng-disabled="button_disable"
                                        spinning-wheel 
                                        is-spinning-wheel-active="button_disable" 
                                >Apply</button>
                            </div>
                            <div>
                        </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				scope.promo = {
					code: ''
				};

				scope.unsubscribe = new Rx.Subject();

				getUser();
				checkSubscriptionInfoUpdates();

				scope.$on('$destroy', () => {
					scope.unsubscribe.next();
					scope.unsubscribe.complete();
				});

				function setAnnualPrice(newVal) {
					if (newVal && newVal.subscriptionPrice) {
						const prices = newVal.subscriptionPrice;
						const annualPrice = prices.annualPrice;
						let discount = null;

						scope.bill = $filter('profilePrice')(annualPrice, 'bill');
						scope.coin = $filter('profilePrice')(annualPrice, 'coin');
						scope.label = $filter('profilePrice')(annualPrice, 'label');

						const annualDiscountPrice = prices.annualDiscountPrice;

						scope.fullPrice = $filter('profilePrice')(
							annualPrice,
							'full-currency-symbol'
						);
						scope.discountPrice = $filter('profilePrice')(
							annualDiscountPrice,
							'full-currency-symbol'
						);

						const promocodeDiscount = prices.discount;

						if (promocodeDiscount) {
							discount = promocodeDiscount.causedByReferral
								? promocodeDiscount.referralDiscount.annualDiscount
								: promocodeDiscount.discount;
						}

						scope.discount = discount
							? $filter('profilePrice')(discount, 'discount')
							: '25%';
					}
				}

				function getUser() {
					accountService.userDataObservable.subscribe(user => {
						if (user !== null && typeof user !== 'undefined') {
							scope.user = JSON.parse(JSON.stringify(user));
							setAnnualPrice(scope.user);
						}
					});
				}

				scope.applyPromoCode = () => {
					const code = scope.promo.code;

					if (validationService.isStringEmpty(code)) {
						messageService.showToaster('e_2', 'promoCodes');
						return;
					}

					scope.button_disable = true;

					promoCodesDataService
						.applyPromoCode(code)
						.finally(() => (scope.button_disable = false))
						.subscribe(
							data => promoCodeService.successApplyPromoCode(data),
							error => promoCodeService.errorApplyPromoCode(error)
						);
				};

				function checkSubscriptionInfoUpdates() {
					promoCodeService.updateSubscriptionPriceObservable
						.takeUntil(scope.unsubscribe)
						.subscribe(() => {
							// scope.user = userService.userData;
							setAnnualPrice(scope.user);
							scope.$digest();
						});
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/helperSubscription/subscriptionAnnualPromo.js